export default __webpack_public_path__ + "872da2e5fcf8fd3368f60a501733ef73.png";